import type { FC, SVGProps } from "react"
import {
	IconAddressBookOutline18,
	IconFileClockOutline18,
	IconSidebarRight2Outline18,
} from "nucleo-ui-outline-18"

import { Badge } from "@productlane/ui"

import { SettingItem } from "../settings-switches/setting-item"
import { SettingsContainer } from "../settings-switches/settings-container"

export const HUBSPOT_ACTIVE_FEATURES: Array<{
	title: string
	description: string
	Icon: FC<SVGProps<SVGSVGElement>>
}> = [
	{
		title: "Panel on contact and company records",
		description:
			"Your team reads support history and files requests from inside HubSpot.",
		Icon: IconSidebarRight2Outline18,
	},
	{
		title: "Daily support notes",
		description:
			"Every morning, each conversation from the past day becomes a note on the matching record.",
		Icon: IconFileClockOutline18,
	},
	{
		title: "Contacts and companies",
		description:
			"New Productlane contacts appear in HubSpot, and existing records link up once a day.",
		Icon: IconAddressBookOutline18,
	},
]

export function HubspotActiveFeatures() {
	return (
		<div className="space-y-4">
			<div className="text-sm font-medium">Active in your HubSpot</div>
			<SettingsContainer>
				{HUBSPOT_ACTIVE_FEATURES.map(({ title, description, Icon }, index) => (
					<SettingItem
						key={title}
						Icon={Icon}
						title={title}
						description={description}
						className={index > 0 ? "pt-4" : undefined}
						action={
							<Badge variant="green" className="flex-none">
								On
							</Badge>
						}
					/>
				))}
			</SettingsContainer>
		</div>
	)
}
